import { FC } from 'react'
import { readAsBase64File } from './readAsBase64File'

export interface Base64File {
  name: string
  type: string
  size: number
  sizeMB: number
  base64: string
  /** Original File, kept so large files can be streamed to S3 without re-encoding. */
  file?: File
}

interface Base64FileInputProps {
  multiple?: boolean
  inputId?: string
  accept?: string
  onChange: (file: Base64File) => void
}

export const Base64FileInput: FC<Base64FileInputProps> = ({
  multiple,
  inputId = 'base64FileInput',
  accept,
  onChange,
}) => {
  const onChangeHandler = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files
    if (!fileList || fileList.length === 0) return
    try {
      const files = await Promise.all(Array.from(fileList).map(readAsBase64File))
      files.forEach((file) => onChange(file))
    } catch {}
  }

  return (
    <input
      type="file"
      id={inputId}
      multiple={multiple}
      accept={accept}
      title=""
      onChange={onChangeHandler}
      tabIndex={-1}
    />
  )
}
